import * as NewsContentGridUploads from "$lib/data/generated/uploads/news/ContentGrid/uploads.js";
import * as NewsFeaturesArticleUploads from "$lib/data/generated/uploads/news/Features Article/uploads.js";
import * as NewsFeaturesArticleAsideUploads from "$lib/data/generated/uploads/news/Features Article Aside/uploads.js";
import * as NewsFeaturesArticleGridUploads from "$lib/data/generated/uploads/news/Features Article Grid/uploads.js";
import * as NewsFormContactNewsUploads from "$lib/data/generated/uploads/news/Form Contact News/uploads.js";
import * as NewsHeadUploads from "$lib/data/generated/uploads/news/Head/uploads.js";
import * as NewsHeadArticleUploads from "$lib/data/generated/uploads/news/Head Article/uploads.js";
import * as NewsMarkedContentArticleUploads from "$lib/data/generated/uploads/news/MarkedContent Article/uploads.js";
import * as NewsPageBannerUploads from "$lib/data/generated/uploads/news/PageBanner/uploads.js";
import * as NewsPageBannerArticleUploads from "$lib/data/generated/uploads/news/PageBanner Article/uploads.js";
import * as NewsRelatedArticlesArticleUploads from "$lib/data/generated/uploads/news/RelatedArticles Article/uploads.js";
import * as NewsTOCArticleUploads from "$lib/data/generated/uploads/news/TOC Article/uploads.js";

export const uploads = {
  ...NewsContentGridUploads.uploads,
  ...NewsFeaturesArticleUploads.uploads,
  ...NewsFeaturesArticleAsideUploads.uploads,
  ...NewsFeaturesArticleGridUploads.uploads,
  ...NewsFormContactNewsUploads.uploads,
  ...NewsHeadUploads.uploads,
  ...NewsHeadArticleUploads.uploads,
  ...NewsMarkedContentArticleUploads.uploads,
  ...NewsPageBannerUploads.uploads,
  ...NewsPageBannerArticleUploads.uploads,
  ...NewsRelatedArticlesArticleUploads.uploads,
  ...NewsTOCArticleUploads.uploads
};
